import React from 'react';
import { motion } from 'framer-motion';
import { BrainIcon, ShieldIcon, TrendingUpIcon, UsersIcon } from 'lucide-react';
export function BenefitsGrid() {
  const benefits = [{
    icon: <BrainIcon className="w-6 h-6 text-[#65A30D]" data-id="element-15" />,
    title: 'Tranquilidad y Foco',
    text: 'Competir con más tranquilidad, foco y valentía en los partidos que más pesan.'
  }, {
    icon: <ShieldIcon className="w-6 h-6 text-[#65A30D]" data-id="element-16" />,
    title: 'Confianza y Resiliencia',
    text: 'Desarrollar confianza real, resiliencia y mejor respuesta al error.'
  }, {
    icon: <TrendingUpIcon className="w-6 h-6 text-[#65A30D]" data-id="element-17" />,
    title: 'Crecimiento Personal',
    text: 'Transformar la presión en una oportunidad de crecimiento y no en una carga.'
  }, {
    icon: <UsersIcon className="w-6 h-6 text-[#65A30D]" data-id="element-18" />,
    title: 'Apoyo Familiar',
    text: 'Aprender como familia a sostener mejor su proceso deportivo y emocional.'
  }];
  return <section className="py-20 md:py-28 bg-[#f8f9fa]" data-id="element-19">
      <div className="max-w-5xl mx-auto px-5 sm:px-6 lg:px-8" data-id="element-20">
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4
      }} className="text-center mb-12 md:mb-16" data-id="element-21">
          <h2 className="text-3xl md:text-4xl font-heading text-brand-slate leading-tight" data-id="element-22">
            Con este producto va a poder:
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-23">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.05
        }} className="bg-white p-6 md:p-8 rounded-2xl border border-gray-100" data-id="element-24">
              <div className="w-12 h-12 rounded-xl flex items-center justify-center mb-5 bg-[#E8F1E4]" data-id="element-25">
                {benefit.icon}
              </div>
              <h3 className="text-xl md:text-2xl font-heading text-brand-slate mb-3" data-id="element-26">
                {benefit.title}
              </h3>
              <p className="text-base md:text-lg text-brand-slate-light leading-relaxed" data-id="element-27">
                {benefit.text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}